/* Hocenlub — About page scroll engine.
   Handles reveal-on-scroll, count-up, hero pinned-zoom, parallax,
   progress bar, and nav solid/hide. Burger + search are wired by the
   aerodisc-nav section's own inline script, so we don't touch them. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nav = document.getElementById('nav');
  var lastY = window.scrollY;

  /* ── Reveal on scroll ── */
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  /* ── Count-up ── */
  function countUp(el) {
    var target = +el.dataset.count, dur = 1700, t0 = null;
    var prefix = el.dataset.prefix || '', suffix = el.dataset.suffix || '', comma = el.dataset.format === 'comma';
    function fmt(n) { n = Math.round(n); return comma ? n.toLocaleString('en-US') : String(n); }
    function step(ts) { if (t0 === null) t0 = ts; var p = Math.min((ts - t0) / dur, 1); var e = 1 - Math.pow(1 - p, 3); el.textContent = prefix + fmt(target * e) + suffix; if (p < 1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  var counts = document.querySelectorAll('[data-count]');
  if ('IntersectionObserver' in window && !reduce) {
    var io2 = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { countUp(e.target); io2.unobserve(e.target); } });
    }, { threshold: 0.5 });
    counts.forEach(function (el) { io2.observe(el); });
  } else {
    counts.forEach(function (el) { var p = el.dataset.prefix || '', s = el.dataset.suffix || '', c = el.dataset.format === 'comma'; el.textContent = p + (c ? (+el.dataset.count).toLocaleString('en-US') : el.dataset.count) + s; });
  }

  /* ── Scroll-driven: hero zoom, parallax, progress bar, nav ── */
  var chero = document.querySelector('.chero'),
      cheroBg = document.getElementById('ab-cheroBg'),
      cheroInner = document.getElementById('ab-cheroInner'),
      cheroShade = document.getElementById('ab-cheroShade'),
      ctaBg = document.getElementById('ab-ctaBg'),
      prog = document.getElementById('ab-prog');
  var paras = [].slice.call(document.querySelectorAll('.parallax'));
  var tick = false;
  function frame() {
    var y = window.scrollY, vh = window.innerHeight;
    /* nav solid + hide-on-scroll-down */
    var open = document.querySelector('.nav-links.open');
    if (nav) {
      nav.classList.toggle('solid', y > 40);
      if (!open && y > 160 && y > lastY + 4) { nav.classList.add('-hidden'); }
      else if (y < lastY - 4 || y <= 160) { nav.classList.remove('-hidden'); }
    }
    lastY = y;
    /* progress bar */
    if (prog) { var sp = document.documentElement.scrollHeight - vh; prog.style.transform = 'scaleX(' + (sp > 0 ? Math.min(y / sp, 1) : 0) + ')'; }
    if (!reduce) {
      /* hero zoom + fade */
      if (chero) {
        var h = chero.offsetHeight - vh; var p = h > 0 ? Math.min(Math.max(y / h, 0), 1) : 0;
        if (cheroBg) cheroBg.style.transform = 'scale(' + (1 + p * 0.16) + ')';
        if (cheroInner) { cheroInner.style.transform = 'translateY(' + (p * -72) + 'px)'; cheroInner.style.opacity = String(Math.max(1 - p * 1.3, 0)); }
        if (cheroShade) cheroShade.style.opacity = String(Math.min(0.4 + p * 0.5, 0.9));
      }
      /* parallax media */
      paras.forEach(function (el) { var r = el.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return; var off = (r.top + r.height / 2 - vh / 2); var img = el.querySelector('img'); if (img) img.style.transform = 'translate3d(0,' + (off * -0.055) + 'px,0)'; });
      if (ctaBg) { var cr = ctaBg.parentNode.getBoundingClientRect(); if (cr.bottom > 0 && cr.top < vh) { var co = (cr.top + cr.height / 2 - vh / 2); ctaBg.style.transform = 'translate3d(0,' + (co * -0.05) + 'px,0)'; } }
    }
    tick = false;
  }
  window.addEventListener('scroll', function () { if (!tick) { requestAnimationFrame(frame); tick = true; } }, { passive: true });
  window.addEventListener('resize', function () { if (!tick) { requestAnimationFrame(frame); tick = true; } }, { passive: true });
  frame();
})();
